import { Component, EventEmitter, Input, Output } from "@angular/core";

@Component({
  selector: "page-generic-search",
  template: "",
  standalone: false
})
export class PageGenericSearchComponent {
  @Input()
  debounceTime: number = 250;

  @Input() placeholder: string | undefined;

  @Output()
  startTyping: EventEmitter<void> = new EventEmitter();

  @Output()
  endTyping: EventEmitter<void> = new EventEmitter();

  @Output()
  search: EventEmitter<string> = new EventEmitter();
}
